import SettlementInfo from "./SettlementInfo";

export default SettlementInfo;